module.exports = __webpack_public_path__ + "static/img/r-5-1.1ed4db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/r-5-1.png
// module id = dfW9
// module chunks = 0